angular.module("folders")

    .controller("FoldersEditModalCtrl", ['folderId', 'parentFolderId', 'entity_type', 'entity_type_id', 'is_public', '$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$filter', 'modalService', '$q', 'LoginService', function (folderId, parentFolderId, entity_type, entity_type_id, is_public, $scope, $uibModalInstance, $uibModal, Restangular, $filter, modalService, $q, LoginService) {

        $scope.allowWrite = true; //LoginService.permissionExist("BUDGET_GROUPS_WRITE");
        if (typeof (folderId) !== "undefined" && folderId != null) {
            Restangular.one('Folders', folderId).get().then(function (results) {
                $scope.folder = results;
            }, function (response) {
                $scope.errorMessage = response.message;
            });
        } else {
            $scope.folder = { parent_folder_id: parentFolderId, entity_type: entity_type, entity_type_id: entity_type_id, is_public: is_public };
        }

        $scope.save = function () {
            if (!angular.isUndefined($scope.folder.id)) {
                $scope.folder.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('restaurants.edit_success'));
                        $uibModalInstance.close();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('Folders').post($scope.folder).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('folders.create_success'));
                        $uibModalInstance.close();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }
        
        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('folders.button_delete'),
                message: $filter('translate')('folders.delete_message') + " " + $scope.folder.name + "?",
                onAccept: function () {
                    $scope.folder.remove().then(function () {
                        toastr.success($filter('translate')('folders.delete_success'));
                        $uibModalInstance.close();
                    });
                }
            });
        };

        $scope.canManageEntityAcl = function (acl) {
            return LoginService.aclEnabled() && LoginService.permissionExist("ACL_MANAGE") && LoginService.userCanManageAcl(acl);
        };
        $scope.aclUsers = [];
        $scope.aclGroups = [];
        $scope.aclOptionsLoaded = false;
        $scope.aclDialogState = { visible: false, savedVersion: 0 };

        let normalizeAclUser = function (user) {
            const name = user.name || user.username || ('User #' + user.id);
            const username = user.username || '';
            const words = name.trim().split(/\s+/);
            const initials = (words.length >= 2 ? words[0][0] + words[words.length - 1][0] : name.slice(0, 2)).toUpperCase();
            return { id: user.id, label: name, initials: initials, sub: (username && username !== name) ? username : (user.email || '') };
        };

        let normalizeAclGroup = function (group) {
            const name = group.name || ('Group #' + group.id);
            return { id: group.id, label: name, initials: name.slice(0, 2).toUpperCase(), sub: group.members_count ? (group.members_count + ' miembros') : '' };
        };

        $scope.loadAclOptions = function () {
            if ($scope.aclOptionsLoaded) return $q.when();
            return $q.all([
                Restangular.all('Users').getList(),
                Restangular.all('UsersGroups').getList()
            ]).then(function (results) {
                $scope.aclUsers = (results[0] || []).map(normalizeAclUser);
                $scope.aclGroups = (results[1] || []).map(normalizeAclGroup);
                $scope.aclOptionsLoaded = true;
            });
        };

        $scope.openAclDialog = function () {
            $scope.loadAclOptions().then(function () {
                $scope.aclDialogState.visible = true;
            });
        };

        $scope.$watch('aclDialogState.savedVersion', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.folder.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('folders.acl_save_success'));
                    }
                });
            }
        });

    }])


;